export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq5_buy.b9715339.mp3";